import React from "react"
import SummaryImage from "../SummaryImage/SummaryImage"

export const ProductImage =(props:any)=>{
    return(
      <div className="product-img">
      {
        props.productId !== '15'?
        (
          <SummaryImage alt={props.title || ""} url={ props.prodcardimage}></SummaryImage>

        )
        :(
          <div className="imageCard">
        <SummaryImage alt={props.title || ""} url={"Product_Illustrations/icon_rocket.svg"}></SummaryImage>
      </div>
        )
      }
    
    </div>
    )
  }